export class ConstantContactStreetAddressPut {

    constructor(
        public kind: string,
        public street: string | null,
        public city: string,
        public state: string | null,
        public postalCode: string,
        public country: string | null
    ){}
}
